import $ from 'jquery';
// eslint-disable-next-line import/extensions
import { PublicClientApplication } from '@azure/msal-browser';

import '../css/common.css';
import '../css/base/button-box.css';
import '../css/base/input-box.css';
import '../css/base/custom-select.css';
import '../css/base/form-wrapper.css';
import '../css/base/message-box.css';
import '../css/index/sub-info.css';

import wording from './wording';
import userLogin from './fetch/userLogin';
import passwordLogin from './fetch/passwordLogin';
import logout from './logout';
import {
	isEntraConfigured,
	loginRequest,
	msalConfig,
} from './entraConfig';
import validateLoginForm from './index/validateLoginForm';
import selectLoginTab from './index/selectLoginTab';
import setupWorknoButton from './index/setupWorknoButton';
import createOption from './index/createOption';
import setupPrgSelectBoxOnChange from './index/onChange/setupPrgSelectBoxOnChange';
import setupLicsnoInputOnChange from './index/onChange/setupLicsnoInputOnChange';
import setupDlrcdSelectBoxOnChange from './index/onChange/setupDlrcdSelectBoxOnChange';

const entraClient = isEntraConfigured ? new PublicClientApplication(msalConfig) : null;
const entraClientReady = entraClient && entraClient.initialize();

const showLoginError = (message) => {
	$('.message-box').text(message);
	$('.message-box').addClass('-warning');
	$('.button-box').removeClass('-loading');
};

const setupWorknoForm = (USERINFO, PRGLIST) => {
	/**
	 * hide the login form
	 * show the workno form
	 */
	$('.body.-login').addClass('-hide');
	$('.body.-workno').removeClass('-hide');
	$('#microsoft-login-button').addClass('-hide');
	$('#password-login-button').removeClass('-hide');
	$('.login-switch').addClass('-hide');

	/**
	 * setup form wording and button status
	 */
	$('.header').text(wording.CHOOSESVID);
	$('#password-login-button > span').text(wording.STARTANSWER);
	$('#password-login-button').removeClass('-loading');
	$('#password-login-button').addClass('-disable');
	$('#password-login-button').off('click');

	/**
	 * reder the list in select box
	 */
	PRGLIST.forEach((listData, index) => {
		$('#prglist-selectbox').append(createOption(listData.PGMNM, index));
	});

	setupPrgSelectBoxOnChange(USERINFO, PRGLIST);
	setupDlrcdSelectBoxOnChange();
	setupLicsnoInputOnChange(USERINFO);
	setupWorknoButton(USERINFO, PRGLIST);
};

const handleLoginResult = (json) => {
	if (!json || json.ResultCode !== '0000') {
		showLoginError(
			(json && (json.ClientMessage || json.ResultMessage)) || wording.LOGINFAILED,
		);

		return false;
	}

	if (!json.ResultData ||
		!Array.isArray(json.ResultData.USERINFO) ||
		!Array.isArray(json.ResultData.PRGLIST)) {
		showLoginError(wording.LOGINFAILED);

		return false;
	}

	setupWorknoForm(json.ResultData.USERINFO, json.ResultData.PRGLIST);

	return true;
};

const passwordLoginSubmitHandler = async () => {
	if (!$('#password-login-button').hasClass('-loading')) {
		$('#password-login-button').addClass('-loading');

		/**
		 * remove error message
		 */
		$('.message-box').removeClass('-warning');
		$('.message-box').text('');

		if (!validateLoginForm('.body.-login')) {
			showLoginError(wording.NOTCOMPLETED);
			return;
		}

		try {
			const json = await passwordLogin({
				USERID: document.querySelector('input[name="USERID"]').value.toUpperCase(),
				PWD: document.querySelector('input[name="PWD"]').value,
			});

			handleLoginResult(json);
		} catch (error) {
			console.error(error);
			showLoginError(wording.LOGINFAILED);
		}
	}
};

const entraLoginSubmitHandler = async () => {
	if (!$('#microsoft-login-button').hasClass('-loading')) {
		$('#microsoft-login-button').addClass('-loading');

		$('.message-box').removeClass('-warning');
		$('.message-box').text('');

		if (!isEntraConfigured) {
			showLoginError(wording.ENTRANOTCONFIGURED);
			return;
		}

		try {
			await entraClientReady;
			const authResult = await entraClient.loginPopup(loginRequest);
			entraClient.setActiveAccount(authResult.account);

			if (!authResult.accessToken) {
				throw new Error('Entra ID did not return an access token');
			}

			console.log(authResult.accessToken);
			const json = await userLogin(authResult.accessToken);

			if (handleLoginResult(json)) {
				$('#logout-button').removeClass('-hide');
			}
		} catch (error) {
			console.error(error);
			showLoginError(wording.LOGINFAILED);
		}
	}
};

$('#password-login-button')
	.on('click', () => passwordLoginSubmitHandler());

$('#microsoft-login-button')
	.on('click', () => entraLoginSubmitHandler());

$('#password-login-tab').on('click', () => selectLoginTab('password'));
$('#entra-login-tab').on('click', () => selectLoginTab('entra'));

$('#logout-button').on('click', async () => {
	try {
		await entraClientReady;
		await logout(entraClient, msalConfig.auth.redirectUri);
		window.location.reload();
	} catch (error) {
		console.error(error);
		showLoginError(wording.LOGOUTFAILED);
	}
});



// WEBPACK FOOTER //
// ./src/js/index.js